import { ISalePageSellerInfoResponse } from '@/api/types';
import { request } from '@/lib/request';
import { AxiosError } from 'axios';
import { createQueryOption } from 'react-query-key-helper';

export const sellerInfoQueryOptions = {
  getSellerInfo: createQueryOption({
    apiUrl: (salePageId: number) => `/sale-pages/${salePageId}/seller-info`,
    queryFn: (apiUrl: string) =>
      request
        .get<ISalePageSellerInfoResponse>(apiUrl)
        .catch((error: AxiosError) => {
          if (error?.response?.status === 404) return null;
          throw error;
        }),
  }),
};
